import { NpvrEventItem } from '@smart-tv/typings/npvr';

import { kmm } from './kmm';
import { mapNpvrEvent } from './npvr-helpers';

export async function getScheduledNpvrEvents(): Promise<NpvrEventItem[]> {
  const events = await kmm((repo) => repo.getScheduledNpvrEvents());

  return events.asJsReadonlyArrayView().map(mapNpvrEvent);
}

export default getScheduledNpvrEvents;
